module.exports = __webpack_public_path__ + "static/media/sort-down.8882034d.svg";